const ITEMS = [
    "DePIN Native",
    "EVM Compatible",
    "Sub-3s Finality",
    "AES-256-GCM Encryption",
    "Reed-Solomon 16/10",
    "AI-Powered Routing",
    "Proof of Storage",
    "On-Chain DNS",
    "Developer Revenue Share",
    "DPoS-BFT Consensus",
    "5,000+ TPS",
    "Patent-Filed Architecture",
];

export default function Marquee() {
    return (
        <section className="relative border-y border-line bg-card-muted overflow-hidden py-5" data-testid="marquee">
            <div className="marquee-track gap-12">
                {[...ITEMS, ...ITEMS].map((t, i) => (
                    <div key={i} className="flex items-center gap-12 shrink-0">
                        <span className="font-mono text-xs uppercase tracking-[0.22em] text-faint-ink whitespace-nowrap">
                            {t}
                        </span>
                        <span className="w-1 h-1 rounded-full bg-brand-cyan/60" />
                    </div>
                ))}
            </div>
        </section>
    );
}
